import Vue from "vue";
import Vuex from "vuex";
import common from "./modules/common";
import { permanent } from "./permanent";
Vue.use(Vuex);
export default new Vuex.Store({
	modules: {
		common,
	},
	plugins: [permanent],
});
